export const weekDaysShort = ["пн", "вт", "ср", "чт", "пт", "сб", "вс"]

export enum INITIATOR {
    CLIENT = "client",
    PSYCHOLOGIST = "psychologist",
}
